jQuery(document).ready(function($) {
console.log( "ready!" );

  $("button#Subscribe.newsletter-form__button.field__button").each(function() {
        var link = $(this);

        var linkText = link.text();

    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });
setTimeout(function() {
    console.log($("div.stamped-review-avatar-content").length);
    $("div.stamped-review-avatar-content").each(function() {
        var link = $(this);
        console.log(link[0]);
        var linkText = link.text();
        link.empty().append('<span class="bc">' + linkText + '</span>');
    });

    $("div.tabs div.tab").each(function() {
        var link = $(this);
        console.log(link[0]);
        var linkText = link.text();
        link.empty().append('<span class="bc">' + linkText + '</span>');
    });
    $("a[id^='CardLink-template']").removeAttr("aria-labelledby");
 $("a[id^='StandardCardNoMediaLink']").removeAttr("aria-labelledby");
  $("a[id^='CardLink']").removeAttr("aria-labelledby");
   $("h3.stamped-review-header-title:empty").append('<span style="display:none"> .</span>');
}, 1000); // 1000 milliseconds (1 second) delay, adjust as needed

  
$('a[href="https://www.facebook.com/nbihealth"]').parent().css("background-color","rgba(0,0,0,0.005) !important");
  $("a[id^='CardLink-template']").removeAttr("aria-labelledby");
 $("a[id^='StandardCardNoMediaLink']").removeAttr("aria-labelledby");
 
  $('img[src="//shop.nbihealth.com/cdn/shop/files/CAR-logo_4color-768x368-1.png?v=1712237879"]').attr('alt', 'Corporate Advisory Round Table Logo');
$('img[src="//shop.nbihealth.com/cdn/shop/files/Bastyr-Logo.png?v=1712237883"]').attr('alt', 'Bastyr University Logo');
$('input[name="q"]').attr('aria-label', 'Enter Search Term');
$('label[for="Search-In-Modal"]').removeAttr('for');
$("li.thumbnail-list__item.slider__slide button.thumbnail.global-media-settings.global-media-settings--no-shadow").removeAttr("aria-describedby")
});


document.addEventListener("DOMContentLoaded", (event) => {
  console.log("DOM fully loaded and parsed");
   console.log($("div.stamped-review-avatar-content").length)
  $("div.stamped-review-avatar-content").each(function() {
        var link = $(this);
  console.log(link[0]);
        var linkText = link.text();
        link.empty().append('<span class="bc">' + linkText + '</span>');
    });

  let Intervaltime_google;
let counter_google = 0; 


try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
}
catch (err) {
  
}


function GenerateAriaLabelForGoogle() {
   
    counter_google++;


   
    if ( $('#goog-gt-votingInputSrcLang').length) {
$("label.adb-switch").append('<span style="display:none">.</span>');

$('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
  $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
  $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
  $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
  $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');
      
        clearInterval(Intervaltime_google);
       
    }
    
  
    if (counter_google >= 10) {
        clearInterval(Intervaltime_google);
       
    }
}
  
});